import { takeLatest, put, call } from "redux-saga/effects"
import {
  fetchBookingDetailsService,
  fetchDaypassBookingByIdService,
  fetchDaypassBookingService,
  modifyCenterService,
  modifyMobileService,
  updateOrderDetailsMarkAsActiveService,
  updateOrderDetailsService,
} from "../services/bookingHistoryService"
import {
  fetchBookingList,
  fetchBookingListSuccess,
  fetchBookingListFailed,
  fetchBookingListPayloadType,
  fetchBookingDetails,
  fetchBookingDetailsSuccess,
  fetchBookingDetailsFailed,
  fetchBookingDetailsPayloadType,
  fetchBookingDetailsByIdSuccess,
  fetchBookingDetailsByIdFailed,
  fetchBookingDetailsById,
  updateOrderDetailsSuccess,
  updateOrderDetailsFailed,
  updateOrderDetails,
  updateOrderDetailsMarkAsActive,
  fetchDaypassBookingByIdPayloadType,
  modifyCenter,
  modifyCenterPayloadType,
  modifyCenterSuccess,
  modifyCenterFailed,
  modifyMobile,
  modifyMobilePayloadType,
  modifyMobileSuccess,
  modifyMobileFailed,
} from "../slices/bookingHistorySlice"
import { AxiosResponse } from "axios"
import { showToast } from "../slices/toastSlice"

export function* fetchBookingListSaga(action: fetchBookingListPayloadType) {
  try {
    const { data }: AxiosResponse = yield call(
      fetchDaypassBookingService,
      action,
    )
    yield put(
      fetchBookingListSuccess({
        bookingList: data?.data || [],
        totalPages: data?.pagination?.pages || 0,
        total: data?.pagination?.total || 0,
      }),
    )
  } catch (err) {
    yield put(fetchBookingListFailed())
  }
}

export function* fetchBookingDetailsByIdSaga(
  action: fetchDaypassBookingByIdPayloadType,
) {
  try {
    const { data } = yield call(fetchDaypassBookingByIdService, action)
    yield put(fetchBookingDetailsByIdSuccess({ bookingDetailsById: data.data }))
  } catch (err) {
    yield put(fetchBookingDetailsByIdFailed())
  }
}

export function* updateBookingOrderDetailsSaga(
  action: fetchDaypassBookingByIdPayloadType,
) {
  try {
    const { data } = yield call(updateOrderDetailsService, action)
    yield put(updateOrderDetailsSuccess({ orderDetails: data.data }))
  } catch (err) {
    yield put(updateOrderDetailsFailed())
  }
}

export function* updateBookingOrderDetailsMarkAsActiveSaga(
  action: fetchDaypassBookingByIdPayloadType,
) {
  try {
    const { data } = yield call(updateOrderDetailsMarkAsActiveService, action)
    yield put(
      showToast({
        toastType: "success",
        msg: "Marked as Active Successfully",
      }),
    )
    yield put(updateOrderDetailsSuccess({ orderDetails: data.data }))
  } catch (err) {
    yield put(updateOrderDetailsFailed())
  }
}

export function* fetchBookingDetailsSaga(
  action: fetchBookingDetailsPayloadType,
) {
  try {
    const { data } = yield call(fetchBookingDetailsService, action)
    yield put(fetchBookingDetailsSuccess({ bookingDetails: data.data }))
  } catch (err) {
    yield put(fetchBookingDetailsFailed())
  }
}

export function* modifyCenterSaga(action: modifyCenterPayloadType) {
  try {
    yield call(modifyCenterService, action)
    const { data } = yield call(fetchDaypassBookingByIdService, action)
    yield put(modifyCenterSuccess({ bookingDetailsById: data.data }))
  } catch (err) {
    yield put(modifyCenterFailed())
  }
}

export function* modifyMobileSaga(action: modifyMobilePayloadType) {
  try {
    yield call(modifyMobileService, action)
    const { data } = yield call(fetchDaypassBookingByIdService, action)
    yield put(modifyMobileSuccess({ bookingDetailsById: data.data }))
  } catch (err) {
    yield put(modifyMobileFailed())
  }
}

export default function* bookingHistorySaga() {
  yield takeLatest(fetchBookingList, fetchBookingListSaga)
  yield takeLatest(fetchBookingDetails, fetchBookingDetailsSaga)
  yield takeLatest(fetchBookingDetailsById, fetchBookingDetailsByIdSaga)
  yield takeLatest(updateOrderDetails, updateBookingOrderDetailsSaga)
  yield takeLatest(
    updateOrderDetailsMarkAsActive,
    updateBookingOrderDetailsMarkAsActiveSaga,
  )
  yield takeLatest(modifyCenter, modifyCenterSaga)
  yield takeLatest(modifyMobile, modifyMobileSaga)
}
